import { useTranslation } from "react-i18next";
import { useTaxType } from "./useTaxType";
import { TaxType } from "common/constants";

/**
 * Hook for changing the html document title
 */
export const useDocumentTitle = () => {
  const { t } = useTranslation();
  const taxType = useTaxType();

  const appName = taxType === TaxType.PST ? t("app_name_pst") : t("app_name");

  return (title: string) => {
    if (title) document.title = `${appName} | ${title}`;
    else document.title = appName;
  };
};
